module.exports = __webpack_public_path__ + "assets/img/35_1116.a1c1b7d8.jpg";